<template>
    <div class="dock-separator"
         :class="{'dock-separator--dragging': dragging}"
         @mousedown.prevent="startDrag"
         @touchstart.prevent="startDrag">
    </div>
</template>

<script>
export default {
    name: 'DockSeparator',
    props: {
        direction: {type: String, default: 'vertical'},
    },
    emits: ['resize'],
    data() {
        return {
            dragging: false,
            startY: 0,
            startX: 0,
        }
    },
    methods: {
        getPointer(e) {
            const src = e.touches && e.touches.length ? e.touches[0] : e
            return {x: src.clientX, y: src.clientY}
        },
        startDrag(e) {
            this.dragging = true
            const p = this.getPointer(e)
            this.startY = p.y
            this.startX = p.x
            this.$emit('resize', {phase: 'start'})
            document.addEventListener('mousemove', this.onDrag)
            document.addEventListener('mouseup', this.stopDrag)
            document.addEventListener('touchmove', this.onDrag, {passive: false})
            document.addEventListener('touchend', this.stopDrag)
        },
        onDrag(e) {
            if (!this.dragging) return
            e.preventDefault()
            const p = this.getPointer(e)
            const dy = this.startY - p.y
            const dx = this.startX - p.x
            this.$emit('resize', {phase: 'move', dy, dx})
        },
        stopDrag() {
            if (!this.dragging) return
            this.dragging = false
            this.$emit('resize', {phase: 'end'})
            document.removeEventListener('mousemove', this.onDrag)
            document.removeEventListener('mouseup', this.stopDrag)
            document.removeEventListener('touchmove', this.onDrag)
            document.removeEventListener('touchend', this.stopDrag)
        },
    },
    beforeUnmount() {
        document.removeEventListener('mousemove', this.onDrag)
        document.removeEventListener('mouseup', this.stopDrag)
        document.removeEventListener('touchmove', this.onDrag)
        document.removeEventListener('touchend', this.stopDrag)
    },
}
</script>
